import React from 'react';

import SkeletonLines from '~/components/core/Skeletons/SkeletonLines';

import GenericClaimBarField from './GenericClaimBarField';

// One line of the cell's own text, so the placeholder is as tall as the headline and value it stands in for.
const lineClassName = 'h-[1lh] w-[100px]';

type SkeletonClaimBarFieldProps = {
  /** A value placeholder built from the cell's own markup, where its value is taller than one line of text. */
  value?: React.ReactNode;
};

const SkeletonClaimBarField = ({ value }: SkeletonClaimBarFieldProps) => (
  <GenericClaimBarField title={<SkeletonLines count={1} lineClassName={lineClassName} />} allowWrapping={false}>
    {value ?? <SkeletonLines count={1} lineClassName={lineClassName} />}
  </GenericClaimBarField>
);

export default SkeletonClaimBarField;
